import React, { useCallback, useState, useMemo } from "react";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { TextInput } from "../UIkit";
import SelectBoxForBase from "../UIkit/SelectBoxForBase";

const useStyles = makeStyles({
  iconCell: {
    padding: 0,
    height: 48,
    width: 48,
  },
  checkIcon: {
    float: "right",
  },
  inputText: {
    display: "flex",
    gap: "10px",
    padding: "0 10px",
  },
  selectBox: {
    width: "100%",
    padding: "0 10px",
  },
});

const SetDepartmentsArea = (props) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0),
    [id, setId] = useState(""),
    [did, setDid] = useState(""),
    [name, setName] = useState(""),
    [baseId, setBaseId] = useState(""),
    [baseName, setBaseName] = useState("");

  const [editingIndex, setEditingIndex] = useState(-1);

  const inputDid = useCallback(
    (event) => {
      setDid(event.target.value);
    },
    [setDid]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );
  const inputBaseInfo = useCallback(
    (value) => {
      setBaseId(value);
      setBaseName(props.bases.find((base) => base.bid === value).name);
    },
    [setBaseId, setBaseName, props.bases]
  );

  const addDepartment = (index, did, name, base_id, base_name) => {
    if (did === "" || name === "" || base_id === "" || base_name === "") {
      return false;
    } else {
      if (index === props.departments.length) {
        props.setDepartments((prevState) => [
          ...prevState,
          {
            id: "",
            did: did,
            name: name,
            base_id: base_id,
            base_name: base_name,
          },
        ]);
        setIndex(index + 1);
        setDid("");
        setName("");
        setBaseId("");
        setBaseName("");
      } else {
        const newDepartments = props.departments;
        newDepartments[index] = {
          ...newDepartments[index],
          did: did,
          name: name,
          base_id: base_id,
          base_name: base_name,
        };
        props.setDepartments(newDepartments);
        setIndex(newDepartments.length);
        setDid("");
        setName("");
        setBaseId("");
        setBaseName("");
      }
      setEditingIndex(-1);
    }
  };

  const editDepartment = (index, did, name, base_id, base_name) => {
    setIndex(index);
    setDid(did);
    setName(name);
    setBaseId(base_id);
    setBaseName(base_name);
    setEditingIndex(index); // 編集中の行をセット
  };

  const deleteDepartment = (deleteIndex) => {
    const newDepartments = props.departments.filter(
      (item, i) => i !== deleteIndex
    );
    props.setDepartments(newDepartments);
  };
  const memoIndex = useMemo(() => {
    setIndex(props.departments.length);
  }, [props.departments.length]);

  return (
    <div aria-label="部署名設定">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          {/* ヘッダー部分はそのまま */}
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>部署名</TableCell>
              <TableCell>拠点名</TableCell>
              <TableCell className={classes.iconCell} />
              <TableCell className={classes.iconCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.departments.length > 0 &&
              props.departments.map((item, i) => (
                <React.Fragment key={i}>
                  {/* 通常の行 */}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {item.did}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.base_name}</TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() =>
                          editDepartment(
                            i,
                            item.did,
                            item.name,
                            item.base_id,
                            item.base_name
                          )
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => deleteDepartment(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* 編集中の行の場合、入力フィールドをここに表示 */}
                  {editingIndex === i && i !== props.departments.length - 1 && (
                    // <TableRow>
                    //     {/* 入力フィールド */}
                    //     <TableCell colSpan={4}>
                    //         {/* ここにTextInputコンポーネント */}
                    //         {/* ... */}
                    //     </TableCell>
                    // </TableRow>
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div>
                          <div className={classes.inputText}>
                            <TextInput
                              fullWidth={false}
                              label={"ID"}
                              multiline={false}
                              required={true}
                              onChange={inputDid}
                              minRows={1}
                              value={did}
                              type={"text"}
                            />
                            <TextInput
                              fullWidth={false}
                              label={"部署名"}
                              multiline={false}
                              required={true}
                              onChange={inputName}
                              minRows={1}
                              value={name}
                              type={"text"}
                            />
                          </div>
                          <div className={classes.selectBox}>
                            <SelectBoxForBase
                              label={"拠点名"}
                              options={props.bases}
                              required={true}
                              select={inputBaseInfo}
                              value={baseId}
                            />
                          </div>
                        </div>
                        <IconButton
                          className={classes.checkIcon}
                          onClick={() =>
                            addDepartment(index, did, name, baseId, baseName)
                          }
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        {/* 編集中の行がない場合、入力フィールドを通常通りここに表示 */}
        {(editingIndex === -1 ||
          editingIndex === props.departments.length - 1) && (
          <>
            <div>
              <div className={classes.inputText}>
                <TextInput
                  fullWidth={false}
                  label={"ID"}
                  multiline={false}
                  required={true}
                  onChange={inputDid}
                  minRows={1}
                  value={did}
                  type={"text"}
                />
                <TextInput
                  fullWidth={false}
                  label={"部署名"}
                  multiline={false}
                  required={true}
                  onChange={inputName}
                  minRows={1}
                  value={name}
                  type={"text"}
                />
              </div>
              <div className={classes.selectBox}>
                <SelectBoxForBase
                  label={"拠点名"}
                  options={props.bases}
                  required={true}
                  select={inputBaseInfo}
                  value={baseId}
                />
              </div>
            </div>
            <IconButton
              className={classes.checkIcon}
              onClick={() => addDepartment(index, did, name, baseId, baseName)}
            >
              <CheckCircleIcon />
            </IconButton>
          </>
        )}
      </TableContainer>
      <div className="module-spacer--small" />
    </div>
  );
};

export default SetDepartmentsArea;
